import {
  Button,
  DialogTriggerProps,
  Heading,
  Link,
  Text,
} from "@chakra-ui/react";
import {
  DialogBackdrop,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from "./ui/dialog";

export default function Credits({ ...props }: DialogTriggerProps) {
  return (
    <DialogRoot placement="center" motionPreset="slide-in-bottom">
      <DialogBackdrop />
      <DialogTrigger {...props} asChild>
        <Button variant="ghost">Créditos</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogCloseTrigger />
        <DialogHeader>
          <DialogTitle>Créditos</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Heading as="h3" fontSize="sm" fontWeight="medium">
            Modelos 3D:
          </Heading>
          <Text>
            Auto{" "}
            <Link href="https://3dexport.com/impozzible" target="_blank">
              Impozzible
            </Link>
          </Text>
          <Text>
            Letrero de velocidad{" "}
            <Link href="https://sketchfab.com/cig3d" target="_blank">
              cig3d
            </Link>
          </Text>
          <Text>
            Cactus{" "}
            <Link href="https://sketchfab.com/Mak_Sensei" target="_blank">
              Mak_Sensei
            </Link>
          </Text>
          <Text>
            Arboles{" "}
            <Link href="https://sketchfab.com/insectscorch" target="_blank">
              3Dimentional
            </Link>
          </Text>
          <Text>
            Postes de luz
            <Link href="https://sketchfab.com/alalys" target="_blank">
              Algirdas Lalys
            </Link>
          </Text>
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
}
